/**
 * Build-time platform (`REACT_APP_PLATFORM` — same role as admin `VITE_APP_PLATFORM`).
 * Dockerfile.mtb.prod → MTB; Dockerfile.dev → IT22.
 * Org white-label is separate (post-login).
 */

export type ProductBrand = 'mindtime' | 'it22';

const platform = (process.env.REACT_APP_PLATFORM || '').toUpperCase();

export const isMindtimeProduct = platform === 'MTB';

export const productBrand: ProductBrand = isMindtimeProduct ? 'mindtime' : 'it22';

export const defaultLogoSrc = isMindtimeProduct
  ? '/static/logo-mindtime.svg'
  : 'https://assets.it22.nl/it22/header/it22-layout-logo-black.webp';

export const loginLogoSrc = isMindtimeProduct
  ? '/static/logo-mindtime.svg'
  : '/static/logo_dark.png';

export const loginPanelBgColor = isMindtimeProduct ? '#1BB4EB' : '#EE3235';

/** White pad so the Mindtime mark stays visible on the brand-blue panel. */
export const loginLogoBoxSx = isMindtimeProduct
  ? {
      bgcolor: 'white',
      borderRadius: '12px',
      p: 1,
      display: 'inline-flex',
      lineHeight: 0,
    }
  : undefined;

export const productLogoAlt = isMindtimeProduct ? 'Mindtime' : 'IT22';

const htmlTitlePrefix = isMindtimeProduct ? 'Mindtime' : 'IT22';

export const getPageTitle = (suffix: string): string =>
  `${htmlTitlePrefix} | ${suffix}`;
